
interface ReviewProps {
  author: string;
  reviewBody: string;
  datePublished: string;
  rating?: number;
}

interface ItemReviewedProps {
  name: string;
  type: "NursingHome" | "Organization" | "Product" | "Service" | "LocalBusiness";
}

/**
 * Generate Review schema for testimonials with proper structure
 * for Google structured data validation
 */
export function generateReviewSchema(reviews: ReviewProps[], itemReviewed: ItemReviewedProps) {
  // Calculate aggregate rating if ratings are available
  const ratingsAvailable = reviews.some(review => review.rating !== undefined);
  let aggregateRating = null;
  
  if (ratingsAvailable) {
    const validRatings = reviews.filter(r => r.rating !== undefined).map(r => r.rating as number);
    const ratingSum = validRatings.reduce((sum, rating) => sum + rating, 0);
    const ratingCount = validRatings.length;
    const ratingAverage = ratingSum / ratingCount;
    
    aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": ratingAverage.toFixed(1),
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": ratingCount
    };
  }

  return {
    "@context": "https://schema.org",
    "@type": itemReviewed.type,
    "name": itemReviewed.name,
    ...(aggregateRating && { "aggregateRating": aggregateRating }),
    "review": reviews.map(review => ({
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": review.author
      },
      "reviewBody": review.reviewBody,
      "datePublished": review.datePublished,
      ...(review.rating && {
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": review.rating,
          "bestRating": "5",
          "worstRating": "1"
        }
      })
    }))
  };
}
